import { render, staticRenderFns } from "./back-arrow.vue?vue&type=template&id=79ee4c7f"
import script from "./back-arrow.vue?vue&type=script&lang=js"
export * from "./back-arrow.vue?vue&type=script&lang=js"
import style0 from "./back-arrow.vue?vue&type=style&index=0&id=79ee4c7f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports